import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { SchedulingDto } from '../model/ms_scheduling_dto';

@Injectable()
export class SchedulingService {

	path = '/scheduling';

	constructor(private baseService: BaseService) {}

	getCalendarEvents(calendarId: string) {
		return this.baseService.get(this.path, `/calendar/${calendarId}/events`);
	}

	create(dto: SchedulingDto) {
		return this.baseService.post(this.path, '/create', dto);
	}

	createCalendar(calendar: { calendarName: string, groupId?: string, userPrincipalName?: string }) {
		return this.baseService.post(this.path, '/calendar', calendar);
	}

	getById(eventId: string) {
		return this.baseService.get(this.path, `/event/${eventId}`);
	}

	updateAsComplete(eventId: string, responseId: string) {
		return this.baseService.put(this.path, `/complete-event/${eventId}?response_id=${responseId}`);
	}

	listCalendars(calendarGroupId = 'default') {
		return this.baseService.get(this.path, `/calendar-groups/${calendarGroupId}/calendars`);
	}

	delete(eventId: string) {
		return this.baseService.delete(this.path, `/event/${eventId}`);
	}

	// legacy routes

	post(content) {
		return this.baseService.post(this.path, '', content);
	}
    getAll() {
        return this.baseService.get(this.path, '')
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/scheduling.service.ts